import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  Row,
  Col,
  Button,
  Table,
  Container,
  Accordion,
  Card,
  Image
} from 'react-bootstrap';

import Link from '../../Link';
import DeclineReasonModal from '../OrderManagement/DeclineReasonModal/DeclineReasonModal';
import ConfirmationPopup from '../../Common/ConfirmationPopup/ConfirmationPopup';
import CurrencyConverter from '../../CurrencyConverter';
import OrderItemThumbnail from '../../Common/OrderItemThumbnail';

import { openDeclineReasonModal, openModal, closeModal } from '../../../actions/siteadmin/modalActions';
import updateItemStatus from '../../../actions/shop/orders/updateItemStatus';
import updateOrderStatus from '../../../actions/shop/orders/updateOrderStatus';
import approveAndSearchDriver from '../../../actions/shop/orders/approveAndSearchDriver';
import { triggerOrderRefetch } from '../../../actions/shop/orders/triggerOrderRefetch';

import { bookingStatusLocale } from '../../../helpers/bookingStatusLocale';
import { isRTL } from '../../../helpers/formatLocale';
import messages from '../../../locale/messages';

// images
import downArrow from '../../../../public/StoreIcon/Dropdownwithcircle20x20.svg';
import upArrow from '../../../../public/StoreIcon/Uparrowwithcircle20x20.svg';
import printIcon from '../../../../public/Icons/printer@2x.png';

import { Query } from 'react-apollo';
import getBookingReviewsQuery from './getOrderReviews.gql';
import StarRating from '../../StarRating/StarRating';

import s from './OrderDetails.css';
import rs from '../../storeCommon.css';
import { FaArrowLeft, FaFileAlt, FaMapMarker, FaPhone, FaStar, FaTruck, FaUser, FaWhatsapp } from 'react-icons/fa';

import { getAvatarUrl, getUiAvatarUrl } from '../../../utils/getAvatarUrl';
import SvgSpinners6DotsScale from '../../Common/Loader/SearchDriverLoader';
import { formatIDR } from '../../../utils/formatIDR';


function CallOrChatActionButtons({ phoneNumber, className }) {
  const removedSpaceInPhoneNumber = phoneNumber.replace(/ /g, '');
  const formattedWhatsappPhoneNumber = removedSpaceInPhoneNumber.replace(/\+/g, '');

  return (
    <div className={`btn-group w-100 ${className}`}>
      <a href={`tel://${removedSpaceInPhoneNumber}`} className='btn btn-outline-secondary'>
        <FaPhone />{' '}
        Call
      </a>
      <a href={`https://wa.me/${formattedWhatsappPhoneNumber}`} className='btn btn-outline-secondary'>
        <FaWhatsapp />{' '}
        Chat
      </a>
    </div>
  )
}


class OrderDetails extends Component {
  static defaultProps = {
    type: 'previous',
    siteCurrency: null
  };

  constructor(props) {
    super(props);

    this.state = {
      buttonLoader: false,
      collapseID: [],
      loading: false
    };
    this.printRef = null;
    this.handleAcceptOrder = this.handleAcceptOrder.bind(this);
    this.handleRejectOrder = this.handleRejectOrder.bind(this);
    this.renderBookingStatus = this.renderBookingStatus.bind(this);
    this.handleDeliveryStatus = this.handleDeliveryStatus.bind(this);
    this.handleButtonLoader = this.handleButtonLoader.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.openPdf = this.openPdf.bind(this);
    this.confirmModalBody = this.confirmModalBody.bind(this);
  }

  componentWillUnmount() {
    clearTimeout(this.buttonLoaderTimeout);
  }

  async handleAcceptOrder(bookingId) {
    const { approveAndSearchDriver, triggerOrderRefetch } = this.props;
    // await updateOrderStatus(bookingId, 'approved', 1, null, true);
    // await updateItemStatus(bookingId, true, 'readyForDelivery');
    await approveAndSearchDriver(bookingId);

    if (triggerOrderRefetch) triggerOrderRefetch();
  }

  async handleRejectOrder(bookingId, orderItemDetails) {
    const { openDeclineReasonModal } = this.props;
    await openDeclineReasonModal(bookingId, 1, orderItemDetails);
  }

  async handleDeliveryStatus(id, status) {
    const { updateItemStatus, closeModal } = this.props;
    const { buttonLoader } = this.state;

    if (!buttonLoader) {
      this.handleButtonLoader(id);
      await updateItemStatus(id, true, status);
      await closeModal('completeConfirmModal');
    }
  }

  handleButtonLoader(id) {
    this.setState({ buttonLoader: true });
    this.buttonLoaderTimeout = setTimeout(() => {
      this.setState({ buttonLoader: false });
    }, 750);
  }

  renderBookingStatus(status, isDoorStepDelivery, deliveryPartnerDetails) {
    const { currentLocale } = this.props;

    if (status === 'readyForDelivery' && isDoorStepDelivery === false) {
      status = 'readyForPickup';
    }

    if (status === 'readyForDelivery' && isDoorStepDelivery === true && deliveryPartnerDetails !== null) {
      status = 'driverFound';
    }
    const statusColor = {
      'pending': 'warning',
      'deliveryNotFound': 'warning',
      'approved': 'info',
      'readyForDelivery': 'info',
      'readyForPickup': 'info',
      'completed': 'success',
      'declined': 'danger',
      'expired': 'secondary',
      'driverFound': 'info'
    }


    if (status) {
      return <div className={`badge badge-${statusColor[status]}`}>{bookingStatusLocale(status, currentLocale)} {status === 'readyForDelivery' && <SvgSpinners6DotsScale />}</div>;
    }
  }

  openPdf() {
    window.print();
  }

  toggleCollapse(id1, id2) {
    const { collapseID } = this.state;
    const index = collapseID.indexOf(id1 + '.' + id2);
    if (index > -1) {
      collapseID.splice(index, 1);
      this.setState({ collapseID });
    } else {
      collapseID.push(id1 + '.' + id2);
      this.setState({ collapseID });
    }
  }

  confirmModalBody(code) {
    const { formatMessage } = this.props.intl;
    return (
      code &&
      <>
        <h4 className={s.completeText}>
          <FormattedMessage {...messages.orderConfirmation} />
        </h4>
        <h5 className={s.confirmCode} >
          {`${formatMessage(messages.confirmationCode)}: ${code}`}
        </h5>
      </>
    )
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { type, data, updateItemStatus, siteCurrency, siteName, intl: { locale }, completeConfirmModal, modalData, openModal, closeModal } = this.props;
    const { buttonLoader, collapseID, loading } = this.state;
    let orderPage, pageType, allowedItemStatus, utcdate, localDate;

    allowedItemStatus = ['approved', 'readyForDelivery'];
    if (data && data.assignDeliveryAt) {
      utcdate = moment.utc(new Date(data.assignDeliveryAt).toUTCString()).format('YYYY-MM-DD HH:mm:ss');
      localDate = moment.utc(utcdate).toDate();
      localDate = moment(localDate).format('YYYY-MM-DD HH:mm:ss');
    }

    if (type === 'previous' || type === 'upcoming') {
      orderPage = 'order-management';
      pageType = type;
    } else {
      orderPage = 'transaction';
      pageType = type === "completed" ? "completed" : "future";
    }

    return (
      <Container ref={el => (this.componentRef = el)} style={{ paddingTop: '6rem' }}>
        {
          type === 'upcoming' && <DeclineReasonModal isOrderDetailPage={true} />
        }
        <div className='printOnly'><h1>{siteName}</h1></div>
        <ConfirmationPopup
          modalStatus={completeConfirmModal}
          title={formatMessage(messages.orderComplete)}
          body={this.confirmModalBody(modalData?.confirmCode)}
          closeModal={() => closeModal('completeConfirmModal')}
          popupButtonLeftName={formatMessage(messages.cancelButton)}
          popupButtonRightName={formatMessage(messages.confirmButton)}
          popupButtonLeftFunction={() => closeModal('completeConfirmModal')}
          popupButtonRightFunction={() => this.handleDeliveryStatus(modalData.id, modalData.status)}
          orderTitle={cx(s.orderTitleText, 'textAlignRightRTL')}
        />
        <Row>
          {
            data &&
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className='d-flex flex-wrap justify-content-between align-items-center mb-4'>
                <div className='d-inline-flex align-items-center'>
                  {!loading &&
                    <Link
                      to={`/store/${orderPage}/${pageType}`}
                      className={cx(rs.button, rs.btnPrimaryBorder, s.displayInlineBtn, 'hidden-print')}>
                      <FaArrowLeft className='mr-2' />
                      <FormattedMessage {...messages.back} />
                    </Link>
                  }
                </div>
                <div>
                  <h1 className='h4 m-0'>
                    <FormattedMessage {...messages.orderDetails} />
                  </h1>
                </div>
                {/*
                      // We disabled the print button for now, because it is not working properly in mobile view

                      <Col lg={4} md={4} sm={4} xs={4}>
                        {
                          data.bookingStatus != 'pending' && <div className={cx(s.receipt, 'receiptBtn', 'textAlignLeftRTL')}>
                            {!loading &&
                              <Button onClick={this.openPdf} className={cx('hidden-print', s.printBtn)} >
                                <FormattedMessage {...messages.printReceipt} /> <img src={printIcon} className={s.printIconCss} />
                              </Button>
                            }
                          </div>
                        }
                      </Col> */}
              </div>

              <div className={cx(s.orderDetailsBg, 'col-12 col-md-6 mx-auto px-0')}>
                <header className={cx(s.detailBg, 'printDetailsBg d-flex justify-content-between align-items-center')}>
                  <div>
                    <div className='text-muted small'><FormattedMessage {...messages.orderId} />:</div>
                    <div className='font-weight-bold'>#{data.orderId}</div>
                  </div>

                  <div>
                    <div className='text-muted small'>
                      <FormattedMessage {...messages.orderStatus} />:
                    </div>
                    <div>
                      {
                        this.renderBookingStatus(data.bookingStatus, data.isDoorStepDelivery, data.deliveryPartnerDetails)
                      }
                    </div>
                  </div>
                </header>

                <div>
                  <section className='my-4 px-4'>
                    <div className='small'>Ordered at:</div>
                    <div>{moment(new Date(data.bookingCreatedAt).toISOString()).format('DD MMMM YYYY HH:mm')}</div>
                    <div className='text-muted small'>({moment(new Date(data.bookingCreatedAt).toISOString()).fromNow()})</div>
                  </section>

                  <section className='px-4'>
                    <div className={cx(s.tableSection, 'orderAccordtionMobile', 'printDetailsBg')}>
                      <p className={cx(s.titleText, rs.space2, rs.spaceTop2, s.textCenter)}><FormattedMessage {...messages.billingDetails} /></p>
                      <Table className={cx(s.table, { [s.directionRTLPrint]: isRTL(locale) })}>
                        <tbody>
                          {
                            data && data.orderItemDetails && data.orderItemDetails.length > 0 && data.orderItemDetails.map((item, key) => {
                              return (
                                <tr key={item.id}>
                                  <td className={cx(s.noBorder, 'orderAccordtionLast', s.displayTableMob, s.displayInlineBtn, 'displayInlineBtnStoreRTL', 'noBorderPrint')}>
                                    <div className='d-flex align-items-center'>
                                      <OrderItemThumbnail image={item.image} name={item.itemName} />
                                      <div className={cx(s.displayTable)}>
                                        <span className={cx(s.orderItem, s.displayTableCell, s.orderWidth, 'orderItemWidth', 'orderItemRTL')}>{item.quantity} x</span>
                                        <span className={s.displayTableCell}>{item.itemName}</span>
                                      </div>
                                    </div>
                                    {
                                      item.orderModifierGroup && item.orderModifierGroup.length > 0 && item.orderModifierGroup.map((groupData, key2) => {
                                        return (
                                          <tr>
                                            <div className='orderAccordion'>
                                              <Accordion defaultActiveKey="0">
                                                <Card className={cx({ [s.orderAccordionPrint]: isRTL(locale) })}>
                                                  <Card.Header>
                                                    <Accordion.Toggle variant="link" eventKey="0" className={cx('arrowBtn', s.displayTable, s.displayTableMob)} onClick={() => this.toggleCollapse(key, key2)}>
                                                      <span className={cx(s.displayTableCell, s.mobDisplayTable)}><img src={collapseID.includes(key + '.' + key2) ? downArrow : upArrow} className={'receiptRTLArrow'} alt="arrow icon" /></span>
                                                      <span className={cx(s.choicsContent, s.displayTableCell, { [s.textRightRTL]: isRTL(locale) })}>
                                                        {groupData.modifierName} {' '}
                                                        (<CurrencyConverter
                                                          from={groupData.currency}
                                                          to={siteCurrency}
                                                          amount={groupData.total}
                                                        />)
                                                      </span>
                                                    </Accordion.Toggle>
                                                  </Card.Header>
                                                  <Accordion.Collapse eventKey="0">
                                                    <Card.Body className={cx({ [s.orderAccordionBodyPrint]: isRTL(locale) })}>
                                                      {
                                                        groupData.orderModifierItem && groupData.orderModifierItem.length > 0 && groupData.orderModifierItem.map((itemData, key) => {
                                                          return (
                                                            <div className={cx(s.quantityGrid, s.marginTop, s.displayTableMob)}>
                                                              <span className={cx(s.orderItem, s.displayTableCell, s.orderWidth, 'orderItemWidth', 'orderItemRTL')}>{itemData.quantity} x</span>
                                                              <span className={cx(s.itemBottom, s.displayTableCell, 'itemBottomPrint', { [s.textRightRTL]: isRTL(locale) }, 'itemBottomRTL', { [s.dGrid]: isRTL(locale) })}><span>{itemData.modifierItemName}</span>
                                                                {itemData.modifierItemPrice && (itemData.modifierItemPrice.toFixed(2) >= 0.01) && <span className={s.dGrid}><span>-</span> <span>(<CurrencyConverter
                                                                  from={itemData.currency}
                                                                  to={siteCurrency}
                                                                  amount={itemData.modifierItemPrice}
                                                                />)</span></span>}
                                                              </span>
                                                            </div>
                                                          )
                                                        })
                                                      }

                                                    </Card.Body>
                                                  </Accordion.Collapse>
                                                </Card>
                                              </Accordion>
                                            </div>
                                          </tr>
                                        );
                                      })
                                    }

                                  </td>
                                  <td className={cx(s.noBorder, rs.alignRightText)}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                                      <span style={item.totalWithDiscount ? { textDecoration: 'line-through', color: '#888', fontSize: '14px', fontStyle: 'italic' } : {}}>


                                        <CurrencyConverter
                                          from={data.currency}
                                          to={siteCurrency}
                                          amount={item.total}
                                        />
                                      </span>
                                      {
                                        item.totalWithDiscount &&
                                        <CurrencyConverter
                                          from={data.currency}
                                          to={siteCurrency}
                                          amount={item.totalWithDiscount}
                                        />
                                      }
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          }

                          {
                            data && data.packagingFee > 0 && <tr>
                              <td className='mt-2'>Packaging Fee:</td>
                              <td className={rs.alignRightText}><CurrencyConverter
                                from={data.currency}
                                to={siteCurrency}
                                amount={data.packagingFee}
                              />
                              </td>

                            </tr>
                          }

                          <tr>
                            <td className={'textAlignRightRTL'}>
                              <span><FormattedMessage {...messages.subTotalLabel} /></span>
                            </td>
                            <td className={rs.alignRightText}>
                              <CurrencyConverter
                                from={data.currency}
                                to={siteCurrency}
                                amount={data.subTotal + (data?.packagingFee || 0)}
                              />
                            </td>
                          </tr>
                          {/* <tr>
                            <td className={'textAlignRightRTL'}>
                              <span><FormattedMessage {...messages.shopFee} /></span>
                            </td>
                            <td className={rs.alignRightText}>
                              -<CurrencyConverter
                                from={data.currency}
                                to={siteCurrency}
                                amount={data.shopServiceFare}
                              />
                            </td>
                          </tr> */}
                          <tr>
                            <td className={cx(s.totalText, 'textAlignRightRTL')}>
                              <span><FormattedMessage {...messages.total} /></span>
                            </td>
                            <td className={cx(s.totalText, rs.alignRightText)}>
                              <CurrencyConverter
                                from={data.currency}
                                to={siteCurrency}
                                amount={data.subTotal + (data?.packagingFee || 0)}
                              />
                            </td>
                          </tr>
                        </tbody>

                      </Table>

                      {data.orderNotes &&
                        <div className='alert alert-info'>
                          <div className='small'>
                            <FaFileAlt />
                            {' '}
                            <FormattedMessage {...messages.orderNotes} />
                          </div>
                          <div className='font-italic'>
                            {data.orderNotes}
                          </div>
                        </div>
                      }

                      {/* Render accept or decline button */}
                      {data.bookingStatus === 'pending' &&
                        <>
                          <p>Please confirm before expired!</p>
                          <div className='btn-group w-100'>
                            <button type="button" className='btn btn-outline-danger' value={'delclined'}
                              onClick={(e) => this.handleRejectOrder(data.id, data.orderItemDetails)}>{formatMessage(messages.rejectedLabel)}</button>
                            <button type="button" className='btn btn-success' value={'approved'}
                              onClick={(e) => this.handleAcceptOrder(data.id)}>{formatMessage(messages.acceptedLabel)}
                            </button>
                          </div>
                        </>
                      }
                    </div>
                  </section>

                  {/* Delivery Partner Details */}
                  {!(['expired', 'declined'].includes(data.bookingStatus)) && data.isDoorStepDelivery &&
                    <section className='mt-4 px-4'>
                      <div className='alert alert-secondary border-0' style={{ backgroundColor: '#F9F7F5' }}>
                        <div className='small mb-2 text-muted'>
                          <FaTruck /> {' '}
                          <FormattedMessage {...messages.deliveryPartnerDetails} />
                        </div>

                        {data.deliveryPartnerDetails &&
                          <>
                            <div className='d-flex align-items-center'>
                              <Image
                                src={data.deliveryPartnerDetails.picture ?
                                  getAvatarUrl(data.deliveryPartnerDetails.picture)
                                  : getUiAvatarUrl(data.deliveryPartnerDetails.firstName)}
                                width={48}
                                height={48}
                                rounded />

                              <div className='ml-2'>
                                <div className={s.subText}>
                                  {data.deliveryPartnerDetails.firstName} {data.deliveryPartnerDetails.lastName}
                                </div>
                                <div className='small text-muted'>
                                  {data.deliveryPartnerDetails.phoneNumber}
                                </div>
                              </div>
                            </div>

                            <CallOrChatActionButtons phoneNumber={data.deliveryPartnerDetails.phoneNumber} className='mt-3' />
                          </>
                        }

                        {!data.deliveryPartnerDetails && data.bookingStatus === 'deliveryNotFound' &&
                          <>
                            <div className='alert alert-warning small mt-3'>
                              <b>⚠️ Driver Not Found</b><br />
                              Unable to find nearby driver. All driver might be in progress delivering.
                              Please try again in a minute.
                            </div>
                            {/* <Button variant='success' className='w-100'>Try again</Button> */}
                            {/* TODO: implement this try again feature */}
                          </>
                        }

                        {/* Ready for pickup (Driver) */}
                        {
                          type === 'upcoming' && data.bookingStatus === 'approved' &&
                          <>
                            <p>Assign driver to pick up the order</p>
                            <div className={cx(s.btn2, rs.space1, rs.spaceTop1)}>
                              <Button
                                className={cx(rs.button, rs.btnPrimary, rs.btnFullWidth, (allowedItemStatus.indexOf(data.bookingStatus) === -1 ? s.btnInactive : ''))}
                                disabled={(allowedItemStatus.indexOf(data.bookingStatus) === -1 ? true : false) || buttonLoader}
                                onClick={() => this.handleDeliveryStatus(data.id, 'readyForDelivery')}
                              >
                                <FormattedMessage {...messages.itemIsDoneLabel} />
                              </Button>
                            </div>
                          </>
                        }
                      </div>
                    </section>
                  }


                  {!(['expired', 'declined'].includes(data.bookingStatus)) && (!data.isDoorStepDelivery) &&
                    <section className='mt-4 px-4'>
                      <div className='alert alert-secondary border-0' style={{ backgroundColor: '#F9F7F5' }}>
                        <div className='small mb-2 text-muted'>
                          <FaTruck />{' '}
                          <FormattedMessage {...messages.deliveryPartnerDetails} />
                        </div>

                        <div className='alert alert-info'>
                          <p className='font-bold'>Self Pickup</p>
                          <div className='small'>Customer will come and pick the order to your location</div>
                        </div>


                        {/* Ready for pickup (self pickup) */}
                        {
                          type === 'upcoming' && data.bookingStatus === 'approved' &&
                          <>
                            <p>Notify customer to pick up the order</p>
                            <div className={cx(s.btn2, rs.space1, rs.spaceTop1)}>
                              <Button
                                variant='success'
                                className='w-100'
                                disabled={(allowedItemStatus.indexOf(data.bookingStatus) === -1 ? true : false) || buttonLoader}
                                onClick={() => this.handleDeliveryStatus(data.id, 'readyForDelivery')}
                              >
                                <FormattedMessage {...messages.itemIsDoneLabel} />
                              </Button>
                            </div>
                          </>
                        }

                        {/* delivery done self pickup order */}
                        {data.bookingStatus === 'readyForDelivery' &&
                          <>
                            <p>Waiting for customer to pickup order...</p>
                            <div className={cx(s.btn2, rs.space1, rs.spaceTop1)}>
                              <Button
                                variant='success'
                                className='w-100'
                                disabled={buttonLoader}
                                onClick={() => openModal('completeConfirmModal', { id: data.id, confirmCode: data.confirmationCode, status: 'completed' })}
                              >
                                <FormattedMessage {...messages.deliveryDone} />
                              </Button>
                            </div>
                          </>
                        }
                      </div>
                    </section>
                  }


                  <section className='mt-4 px-4'>
                    {
                      data.userDetails &&
                      <div className='alert alert-secondary border-0' style={{ backgroundColor: '#F9F7F5' }}>
                        <div className='small mb-2 text-muted'>
                          <FaUser /> {' '}
                          <FormattedMessage {...messages.userDetails} />
                        </div>

                        <div className='d-flex align-items-center'>
                          <Image
                            src={data.userDetails.picture ? getAvatarUrl(data.userDetails.picture) : getUiAvatarUrl(data.userDetails.firstName)}
                            width={48}
                            height={48}
                            rounded />

                          <div className='ml-2'>
                            <div className={s.subText}>
                              {data.userDetails.firstName} {data.userDetails.lastName}
                            </div>
                            <div className='small text-muted'>
                              {data.userDetails.phoneNumber}
                            </div>
                          </div>
                        </div>

                        {/* Action button */}
                        <CallOrChatActionButtons phoneNumber={data.userDetails.phoneNumber} className='mt-3' />
                      </div>
                    }
                  </section>


                  {/* Delivery location */}
                  {data.isDoorStepDelivery &&
                    <section className='mt-1 px-4'>
                      <div className='alert alert-secondary border-0' style={{ backgroundColor: '#F9F7F5' }}>
                        <div className='small mb-2 text-muted'>
                          <FaMapMarker />
                          <FormattedMessage {...messages.deliveryLocations} />
                        </div>
                        <div className=''>
                          {data.dropOffLocation}
                        </div>
                      </div>
                    </section>
                  }


                  {!data.isDoorStepDelivery &&
                    data.deliveryInstruction &&
                    <section className='px-4'>
                      <div className=''><FormattedMessage {...messages.pickupInstruction} /></div>
                      <div className=''>
                        {data.deliveryInstruction}
                      </div>
                    </section>
                  }

                  {/* Customer Reviews */}
                  <Query
                    query={getBookingReviewsQuery}
                    variables={{ bookingId: data.id }}
                    fetchPolicy="network-only"
                  >
                    {({ loading: reviewsLoading, data: reviewsData }) => {
                      if (reviewsLoading) return null;
                      const reviews = reviewsData?.getShopBookingReviews?.results || [];
                      if (reviews.length === 0) return null;

                      const shopReview = reviews.find(r => r.userData?.userType === 3);
                      const driverReview = reviews.find(r => r.userData?.userType === 2);
                      const isDoorStep = data.isDoorStepDelivery;

                      return (
                        <section className='mt-4 px-4 pb-4'>
                          <div className='small mb-3 text-muted font-weight-bold border-bottom pb-2'>
                            <FaStar className='mr-1 text-warning' />
                            Customer Reviews
                          </div>
                          <Row>
                            {shopReview && (
                              <Col md={isDoorStep ? 6 : 12}>
                                <div className='border rounded p-3 mb-3'>
                                  <p className='font-weight-bold mb-2'>Review to Shop</p>
                                  <StarRating
                                    name="shop-review"
                                    value={shopReview.ratings}
                                    editing={false}
                                  />
                                  <p className='mt-2 mb-1 text-muted small'>{shopReview.reviewContent}</p>
                                  <small className='text-muted'>by {shopReview.authorData?.firstName || 'Customer'}</small>
                                </div>
                              </Col>
                            )}
                            {isDoorStep && driverReview && (
                              <Col md={6}>
                                <div className='border rounded p-3 mb-3'>
                                  <p className='font-weight-bold mb-2'>Review to Driver</p>
                                  <StarRating
                                    name="driver-review"
                                    value={driverReview.ratings}
                                    editing={false}
                                  />
                                  <p className='mt-2 mb-1 text-muted small'>{driverReview.reviewContent}</p>
                                  <small className='text-muted'>by {driverReview.authorData?.firstName || 'Customer'}</small>
                                </div>
                              </Col>
                            )}
                          </Row>
                        </section>
                      );
                    }}
                  </Query>

                </div>
              </div>

            </Col>
          }
        </Row>
      </Container>
    );
  }
};

const mapState = (state) => ({
  siteCurrency: state.siteSettings?.data?.currency,
  currentLocale: state.intl.locale,
  siteName: state.siteSettings.data.siteName,
  completeConfirmModal: state.modalStatus.completeConfirmModal,
  modalData: state.modalStatus.data && state.modalStatus.data[0],
})

const mapDispatch = {
  updateOrderStatus,
  approveAndSearchDriver,
  openDeclineReasonModal,
  updateItemStatus,
  openModal,
  closeModal,
  triggerOrderRefetch
}

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(OrderDetails)));
